import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { breakpoints, spaces } from '@99designs/common/core/settings';

interface Props {
    size?: Sizes;
    children: ReactNode;
}

interface StyledContentSettingProps {
    maxWidth: string;
}

const StyledContentSetting = styled.div<StyledContentSettingProps>`
    max-width: ${props => props.maxWidth};
    position: relative;
    margin: auto;
    padding-left: ${spaces.gutter}px;
    padding-right: ${spaces.gutter}px;

    @media screen and (max-width: ${breakpoints.small[1]}px) {
        padding-left: ${spaces.halfGutter}px;
        padding-right: ${spaces.halfGutter}px;
    }
`;

export const enum Sizes {
    Default = '1000px',
    Small = '650px',
    Full = 'initial',
}

export default function ContentSetting({ size, children }: Props) {
    return (
        <StyledContentSetting maxWidth={size ? size : Sizes.Default}>
            {children}
        </StyledContentSetting>
    );
}
